/* Everest Paints - Article TOC (robust for Shopify theme editor) */
(function () {
  function slugify(str) {
    return String(str)
      .trim()
      .toLowerCase()
      .replace(/['"]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "");
  }

  function uniqueId(base, used) {
    let id = base;
    let i = 2;
    while (used.has(id)) {
      id = `${base}-${i}`;
      i += 1;
    }
    used.add(id);
    return id;
  }

  function setOpen(tocEl, open) {
    tocEl.setAttribute("data-open", open ? "true" : "false");
    const toggle = tocEl.querySelector("[data-ep-toc-toggle]");
    if (toggle) toggle.setAttribute("aria-expanded", open ? "true" : "false");
  }

  function getOffsetTop(el) {
    const rect = el.getBoundingClientRect();
    return rect.top + window.scrollY;
  }

  function smoothScrollTo(target) {
    const y = getOffsetTop(target);
    const offset = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue("--ep-scroll-offset") || "0",
      10
    );
    window.scrollTo({ top: Math.max(0, y - offset), behavior: "smooth" });
  }

  function buildTOC(tocEl) {
    if (!tocEl) return;

    const content =
  document.querySelector("[data-ep-article-content]") ||
  document.querySelector('[itemprop="articleBody"]');

    if (!content) return false; // tell caller to retry

    const includeH3 = tocEl.dataset.includeH3 === "true";
    const parsedMin = parseInt(tocEl.dataset.minHeadings || "", 10);
    const minHeadings = Number.isFinite(parsedMin) ? parsedMin : 3; // NaN-safe fallback

    const selector = includeH3 ? "h2, h3" : "h2";
    const headings = Array.from(content.querySelectorAll(selector))
      .filter(h => h.textContent && h.textContent.trim().length > 0);

    const h2Count = headings.filter(h => h.tagName.toLowerCase() === "h2").length;

    // Hide TOC if not enough headings
    if (h2Count < minHeadings) {
      tocEl.style.display = "none";
      return true;
    } else {
      tocEl.style.display = "";
    }

    // Ensure headings have IDs
    const used = new Set();
    headings.forEach(h => {
      if (h.id) {
        used.add(h.id);
        return;
      }
      const base = slugify(h.textContent);
      h.id = uniqueId(base || "section", used);
    });

    // Build nested list
    const nav = tocEl.querySelector("[data-ep-toc-nav]");
    if (!nav) return true;

    const ul = document.createElement("ul");
    let currentH2Li = null;

    headings.forEach(h => {
      const level = h.tagName.toLowerCase();
      const li = document.createElement("li");
      const a = document.createElement("a");
      a.href = `#${h.id}`;

      // Optional: strip leading "1. " from TOC labels
      const raw = h.textContent.trim();
      a.textContent = raw.replace(/^\d+\.\s*/, "");

      a.addEventListener("click", (e) => {
        e.preventDefault();
        const target = document.getElementById(h.id);
        if (target) smoothScrollTo(target);
        if (window.matchMedia("(max-width: 989px)").matches) setOpen(tocEl, false);
      });

      li.appendChild(a);

      if (level === "h2") {
        ul.appendChild(li);
        currentH2Li = li;
      } else {
        if (!currentH2Li) {
          ul.appendChild(li);
          return;
        }
        let sub = currentH2Li.querySelector("ul");
        if (!sub) {
          sub = document.createElement("ul");
          sub.className = "ep-toc__sub";
          currentH2Li.appendChild(sub);
        }
        sub.appendChild(li);
      }
    });

    nav.innerHTML = "";
    nav.appendChild(ul);

    // Mobile toggle
    const toggle = tocEl.querySelector("[data-ep-toc-toggle]");
    if (toggle && !toggle.dataset.bound) {
      toggle.dataset.bound = "true";
      toggle.addEventListener("click", () => {
        const isOpen = tocEl.getAttribute("data-open") === "true";
        setOpen(tocEl, !isOpen);
      });
    }

    // Default open state
    if (window.matchMedia("(min-width: 990px)").matches) setOpen(tocEl, true);
    else setOpen(tocEl, false);

        // Active section highlighting (supports Overview / non-heading items too)
    const links = Array.from(nav.querySelectorAll("a"));

    function setActiveById(id) {
      links.forEach(a => {
        const isMatch = a.getAttribute("href") === `#${id}`;
        a.dataset.active = isMatch ? "true" : "false";
        a.classList.toggle("is-active", isMatch); // keeps your CSS options flexible
      });
    }

    function setActiveFirst() {
      const first = links[0];
      if (!first) return;
      const firstId = (first.getAttribute("href") || "").replace("#", "");
      if (firstId) setActiveById(firstId);
    }

    if ("IntersectionObserver" in window) {
      const obs = new IntersectionObserver((entries) => {
        const visible = entries
          .filter(e => e.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

        if (visible.length > 0) {
          setActiveById(visible[0].target.id);
          return;
        }

        // If nothing is intersecting and we're near the top, default to Overview (first link)
        if (window.scrollY < 80) setActiveFirst();
      }, {
        root: null,
        rootMargin: "-15% 0px -75% 0px",
        threshold: 0.01
      });

      // Observe all heading targets
      headings.forEach(h => obs.observe(h));

      // Also observe any TOC targets that aren't headings (e.g. Overview)
      links.forEach(a => {
        const id = (a.getAttribute("href") || "").replace("#", "");
        if (!id) return;
        const el = document.getElementById(id);
        if (el) obs.observe(el);
      });

      // Initial state: hash wins, otherwise Overview (first item) is active by default
      const hash = (window.location.hash || "").replace("#", "");
      if (hash) setActiveById(hash);
      else setActiveFirst();
    } else {
      // No IntersectionObserver: default to first item
      setActiveFirst();
    }


    return true;
  }

  function initAllWithRetry(retries = 10) {
    const tocs = Array.from(document.querySelectorAll("[data-ep-toc]"));
    if (!tocs.length) return;

    let allDone = true;
    tocs.forEach(tocEl => {
      const done = buildTOC(tocEl);
      if (!done) allDone = false;
    });

    if (!allDone && retries > 0) {
      setTimeout(() => initAllWithRetry(retries - 1), 150);
    }
  }

  document.addEventListener("DOMContentLoaded", () => initAllWithRetry());

  // Shopify theme editor: sections re-render without full page reload
  document.addEventListener("shopify:section:load", () => initAllWithRetry());
  document.addEventListener("shopify:section:reorder", () => initAllWithRetry());
  document.addEventListener("shopify:section:select", () => initAllWithRetry());
})();
